<template>
  <div class="row charges-extra-parameters-input-widgets">
    <div v-for="[attr, field] in sortedExtraParameters" :class="inputClass" :key="field.key">
      <input-widget :model="model" :type="field.type" :key="attr" :rules="field.rules"
                    :attribute="`${attr}`" :label="field.label"/>
    </div>
  </div>
</template>

<script>
  import InputWidget from "@/core/components/input-widget/InputWidget";

  export default {
    name: "ChargeExtraParametersInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true,
      },
      extra_parameters_template: {
        type: Object,
        required: true,
      },
      inputClass: {
        type: String,
        default: 'col-md-12'
      },
    },
    computed: {
      sortedExtraParameters() {
        let sortedParams = [];
        for (const [attr, field] of Object.entries(this.extra_parameters_template)) {
          sortedParams.push([attr, field]);
        }
        sortedParams.sort(function (a, b) {
          return a[1].position - b[1].position;
        });

        return sortedParams
      }
    }
  }
</script>

<style scoped>

</style>